function PopupContainer() {
    return <div id="popup-container" style={{ position: 'relative', width: '100%', height: '100%' }} />;
}

export default PopupContainer;
